module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="mapTooltip">\n    ';
 if (marker.type) { 
__p+='\n    <div class="mapTooltip__heading">\n        <div class="grid__row">\n            ';
 if (marker.type === 'home') { 
__p+='\n            <div class="grid__1of6 u-textCenter">\n                <i class="icon icon-home"></i>\n            </div>\n            <div class="grid__5of6">\n                <div class="mapTooltip__headingTitle"><span class="u-textItalic">Your</span> InterNations Community:</div>\n            </div>\n            ';
 } else if (marker.type === 'visit') { 
__p+='\n            <div class="grid__1of6 u-textCenter">\n                <i class="icon icon-travel"></i>\n            </div>\n            <div class="grid__5of6">\n                <div class="mapTooltip__headingTitle">You are currently visiting:</div>\n            </div>\n            ';
 } 
__p+='\n        </div>\n    </div>\n    ';
 } 
__p+='\n\n    <div class="js-map-tooltip mapTooltip__content localcommunityAllInternations__mapTooltip">\n        <div class="grid__row u-halfSpaceBottom">\n            <div class="grid__1of6 u-textCenter">\n                <i class="flag-32 flag-'+
((__t=( marker.iocCode ))==null?'':_.escape(__t))+
'"></i>\n            </div>\n            <div class="grid__5of6">\n                <h3 class="u-noMargin">\n                    <a class="js-community-link"\n                        data-id="'+
((__t=( marker.id ))==null?'':_.escape(__t))+
'"\n                        data-name="'+
((__t=( marker.name ))==null?'':_.escape(__t))+
'"\n                        data-url-name="'+
((__t=( marker.urlName ))==null?'':_.escape(__t))+
'"\n                        href="javascript:void(0);">\n                        '+
((__t=( marker.name ))==null?'':_.escape(__t))+
' | '+
((__t=( marker.countryName ))==null?'':_.escape(__t))+
'\n                    </a>\n                </h3>\n                <div class="metaInformation">local time: '+
((__t=( marker.localTime ))==null?'':_.escape(__t))+
' (UTC'+
((__t=( marker.timezone ))==null?'':_.escape(__t))+
')</div>\n            </div>\n        </div>\n\n        <div class="grid__row">\n            <div class="grid__1of1">\n                <hr>\n            </div>\n        </div>\n\n        ';
 if (marker.ambassadors) { 
__p+='\n        <div class="grid__row">\n            <div class="grid__1of6 u-textCenter">\n                <span class="icon icon-ambassador-midGrey"></span>\n            </div>\n            <div class="grid__5of6">\n                <p class="u-noMargin">\n                    '+
((__t=( marker.ambassadors ))==null?'':_.escape(__t))+
'\n                </p>\n            </div>\n        </div>\n        ';
 } 
__p+='\n\n        ';
 if (marker.memberCount) { 
__p+='\n        <div class="grid__row localcommunityAllInternations__tooltipListItem">\n            <div class="grid__1of6 u-textCenter">\n                <span class="icon icon-nationality-midGrey"></span>\n            </div>\n            <div class="grid__5of6">\n                <p class="u-noMargin">\n                    '+
((__t=( formatNumber(marker.memberCount) ))==null?'':_.escape(__t))+
' members from '+
((__t=( formatNumber(marker.nationalityCount) ))==null?'':_.escape(__t))+
'\n                    different countries\n                </p>\n            </div>\n        </div>\n        ';
 } 
__p+='\n\n        ';
 if (marker.groupCount && marker.groupConsulCount) { 
__p+='\n        <div class="grid__row localcommunityAllInternations__tooltipListItem">\n            <div class="grid__1of6 u-textCenter">\n                <span class="icon icon-group-midGrey"></span>\n            </div>\n            <div class="grid__5of6">\n                <p class="u-noMargin">\n                    '+
((__t=( formatNumber(marker.groupCount) ))==null?'':_.escape(__t))+
' InterNations Group'+
((__t=( formatNumber(marker.groupCount) > 1 ? 's' : '' ))==null?'':_.escape(__t))+
'\n                    organized by '+
((__t=( formatNumber(marker.groupConsulCount) ))==null?'':_.escape(__t))+
' Consul'+
((__t=( formatNumber(marker.groupConsulCount) > 1 ? 's' : '' ))==null?'':_.escape(__t))+
'\n                </p>\n            </div>\n        </div>\n        ';
 } 
__p+='\n\n        ';
 if (marker.monthlyEventCount) { 
__p+='\n        <div class="grid__row localcommunityAllInternations__tooltipListItem">\n            <div class="grid__1of6 u-textCenter">\n                <span class="icon icon-calendar-midGrey"></span>\n            </div>\n            <div class="grid__5of6">\n                <p class="u-noMargin">\n                    '+
((__t=( formatNumber(marker.monthlyEventCount) ))==null?'':_.escape(__t))+
' events and activities taking place each month\n                </p>\n            </div>\n        </div>\n        ';
 } 
__p+='\n    </div>\n</div>\n';
}
return __p;
};
